<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <!--template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Open Dialog
        </v-btn>
      </template-->
      <v-card>
        <v-toolbar
          dark
          color="primary"
          style="border-radius: 0"
          elevation="0"
        >
          <v-btn
            icon
            dark
            @click="onClose"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t('dtouch.dishOrders.title', locale)}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <!--v-toolbar-items>
            <v-btn
              dark
              text
              @click="dialog = false"
            >
              Save
            </v-btn>
          </v-toolbar-items-->
        </v-toolbar>
        <div style="padding: 10px;" v-if="order">
          <expand-item
            :headers="headers"
            :item="order"
            :locale="locale"
            :onDelete="handleDeleteOrder"
            :onClose="handleCloseOrder"
            :onFinalize="handleFinalizeOrder"
            :note="note"
            :currency="currency"
            :percentage="percentage"
            :allInclusive="allInclusive"
          />
        </div>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import apiDishOrders from '@/services/apiDishOrders'
import utils from '@/services/utils'
import ExpandItem from './ordersList/ExpandItem'
export default {
  components: {
    ExpandItem,
  },
  props: {
    orderID: {
      type: String,
      default: null,
    },
    onClose: {
      type: Function,
      required: true,
    },
    locale: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    dialog: false,
    order: null,
    currency: null,
    percentage: null,
    allInclusive: null,
    note: null,
  }),
  computed: {
    headers() {
      return [
        {
          text: this.$t('dtouch.dishOrders.points.order', this.locale),
          align: 'start',
          value: 'ID',
        },
      ]
    },
  },
  watch: {
    orderID () {
      this.prepareOrder()
    },
  },
  mounted () {
    this.handleGetConfig()
  },
  methods: {
    handleGetConfig () {
      apiDishOrders.getConfig ()
        .then(response => {
          this.currency = response && response.Currency ? response.Currency : '€'
          this.percentage = response && response.Percentage ? response.Percentage : null
          this.note = response && response.Note ? JSON.parse(response.Note) : null
          this.allInclusive = response && response.AllInclusive ? true : false
          this.prepareOrder()
        })
    },
    prepareOrder () {
      this.dialog = false
      if (this.orderID && this.orderID.length > 0) {
        apiDishOrders.getOrderItem(this.orderID)
          .then((response) => {
            this.order = response.data.orders.shift()
            console.log('orderitem', response.data)
            this.dialog = true
          })
      }
    },
    handleDeleteOrder (v) {
      apiDishOrders.deleteOrder(v, 'private') 
        .then(() => {
          this.onClose()
        })
    },
    handleCloseOrder (v) {
      apiDishOrders.closeOrder(v) 
        .then(() => {
          this.onClose()
        })
    },
    handleFinalizeOrder (v) {
      apiDishOrders.finalizeOrder(v) 
        .then(() => {
          this.onClose()
        })
    },
  },
}
</script>
